<!-- eslint-disable  -->
<div class="search-bar" (click)="$event.stopPropagation()">
    <div class="input-group" *ngIf="!selectedSubGroupAccount">
        <input class="form-control global-ai-search-input py-2 border-right-0 border" autocomplete="off" type="search"
            id="example-search-input" placeholder="{{placeHolder | translate}}" [(ngModel)]="searchInput"
            (ngModelChange)="onSearchSite()">
    </div>
    <div class="active-selection-section" *ngIf="tabValue.showActiveData && tabValue.activeData && !isloading && !searchInput">
        <nalco-divider *ngIf="!selectedSubGroupAccount" [color]="dividerCss.color" [length]="dividerCss.minLength"
            [isHorizontal]=dividerCss.isHorizontal></nalco-divider>
        <div class="selected-heading" *ngIf="selectedSubGroupAccount"><span
                (click)="setInitialData()"><img
                    src="./../../../../../assets/images/global-search/arrow-left.svg"></span>
            {{'COMMON.GLOBAL_SEARCH.SUB_GROUPS.SELECT_SUBGROUPS' | translate}} -
            {{selectedSubGroupAccount}}</div>
        <div class="active-selection-bg" *ngIf="!tabValue.enableSelectionButtons && !searchInput">
            <div class="active-selection-flex">
                <div class="selection">
                    <div class="selection-heading-row">
                        <div class="heading">
                            {{'COMMON.GLOBAL_SEARCH.ACTIVE_SELECTION' | translate}}
                            <span
                                *ngIf="tabValue.enableCustomerDivisionSelection && tabValue?.activeData?.selectionHierarchy?.length > 0">
                                ({{'COMMON.GLOBAL_SEARCH.SUB_GROUP' | translate}})
                            </span>
                        </div>
                        <div class="clear-selection" (click)="clearActiveSelection()">
                            {{'COMMON.GLOBAL_SEARCH.CLEAR_SELECTION' | translate}}
                            <span>
                                <img src="./../../../../../assets/images/filter-icons/close-button.svg">
                            </span>
                        </div>
                    </div>
                    <!-- Name and Subgroups on same line -->
                    <div class="selection-name-row">
                        <div class="active-selection-name">
                            {{tabValue?.activeData?.contextPointName}}
                        </div>

                        <ng-container *ngIf="tabValue.enableCustomerDivisionSelection">
                            <div *ngIf="tabValue?.activeData?.selectionHierarchy?.length === 0" class="subgroups"
                                (click)="onSelectSubGroups()">
                                <span>
                                    <img src="./../../../../../assets/images/global-search/subgroup-icon.svg" />
                                </span>
                                {{'COMMON.GLOBAL_SEARCH.SUB_GROUPS.SELECT_SUBGROUPS' | translate}}
                            </div>
                            <div *ngIf="tabValue?.activeData?.selectionHierarchy?.length > 0" class="subgroups"
                                (click)="updateSubGroups()">
                                <span>
                                    <img src="./../../../../../assets/images/global-search/subgroup-icon.svg" />
                                </span>
                                {{'COMMON.GLOBAL_SEARCH.SUB_GROUPS.EDIT_SUBGROUPS' | translate}}
                            </div>
                        </ng-container>
                    </div>
                    <span class="secondary-text" *ngIf="tabValue?.activeData.secondaryText"
                        [innerHTML]="tabValue.activeData?.secondaryText"></span>
                </div>
            </div>
        </div>
        <br />
    </div>
    <div *ngIf="selectedChips?.length > 0">
        <nalco-divider *ngIf="!tabValue?.activeData" [color]="dividerCss.color" [length]="dividerCss.minLength"
            [isHorizontal]=dividerCss.isHorizontal></nalco-divider>
        <div class="margin-heading"> <span class="results-heading">Selections </span>
            <span class="length-chip">{{selectedChips?.length}}</span>
            <span class="float-end clearAll" (click)="setInitialData()">Clear All</span>
        </div>

        <div class="chip-list">
            <div style="display:flex;" *ngFor="let item of selectedChips;let i = index">
                <div class="chips">
                    <span>{{item.contextPointName}}</span>
                    <img (click)="removeChipAtIndex(i)"
                        src="./../../../../../assets/images/filter-icons/close-button.svg" alt="close">
                </div>
                <div class="chips-nav">
                    <img *ngIf="i < (selectedChips?.length - 1)" class="nav-icon"
                        src="./../../../../../assets/images/global-search/nav_icon.svg" alt="nav">
                </div>
            </div>
        </div>
    </div>
    <div class="search-bar-menu">
        <ul *ngIf="!isloading">
            <div class="search-result">
                <nalco-result-list
                    *ngIf="!initiateManualSearch && tabValue?.recentsData?.length > 0 && !searchInput && selectedChips?.length === 0 && tabValue.showRecents"
                    [heading]="'COMMON.GLOBAL_SEARCH.RECENTS'" [items]="tabValue.recentsData"
                    [selectedItem]="selectedItem" [searchInput]="searchInput" [iconClass]="'search-history-icon'"
                    [listIconPath]="'../../../../../assets/images/global-search/search-history.svg'"
                    (itemSelected)="getSelectedInfo($event)" [displaySecondaryText]="true"></nalco-result-list>
                <div
                    *ngIf="searchInput && !initiateManualSearch && tabValue.enableMultiLevelSearchInContext; else singleSearchResult">
                    <div *ngFor="let filter of tabValue.hierarchyValues;let i = index">
                        <nalco-result-list [heading]="filter.name"
                            [items]="filterResults(filter.searchResults? filter.searchResults : [],this.tabValue.hierarchyValues[i].contextPointIdKeys[1])"
                            [selectedItem]="selectedItem" [searchInput]="searchInput" [iconClass]="'search-result-icon'"
                            [listIconPath]="'../../../../../assets/images/global-search/search-bar-icon.svg'"
                            (itemSelected)="createHierarchy($event,i)" [setHeight]="false" [displayResultCount]="true"
                            [displaySecondaryText]="true"></nalco-result-list>
                    </div>
                </div>
                <ng-template #singleSearchResult>
                    <nalco-result-list
                        *ngIf="searchInput && !initiateManualSearch && tabValue?.searchResults?.length > 0"
                        [heading]="tabValue.name" [items]="tabValue?.searchResults" [selectedItem]="selectedItem"
                        [searchInput]="searchInput" [iconClass]="'search-result-icon'"
                        [listIconPath]="'../../../../../assets/images/global-search/search-bar-icon.svg'"
                        (itemSelected)="checkHierarchy($event)" [setHeight]="false" [displayResultCount]="true"
                        [displaySecondaryText]="true"></nalco-result-list>
                </ng-template>
                <nalco-result-list *ngIf="!initiateManualSearch && !searchInput && tabValue?.favouritesData?.length > 0"
                    [heading]="'COMMON.GLOBAL_SEARCH.FAVORITES'" [items]="tabValue?.favouritesData"
                    [selectedItem]="selectedItem" [searchInput]="searchInput" [iconClass]="'favourite-icon'"
                    [listIconPath]="'../../../../../assets/images/global-search/favourites-icon.svg'"
                    (itemSelected)="getSelectedInfo($event)" [setHeight]="false"></nalco-result-list>
                <nalco-result-list *ngIf="!initiateManualSearch && !searchInput && tabValue?.defaultData?.length < 10"
                    [heading]="getTranslatedHeading()" [items]="tabValue?.defaultData" [selectedItem]="selectedItem"
                    [searchInput]="searchInput" [iconClass]="'search-result-icon'"
                    [listIconPath]="'../../../../../assets/images/global-search/search-bar-icon.svg'"
                    (itemSelected)="getSelectedInfo($event)" [setHeight]="false"></nalco-result-list>

                <nalco-result-list
                    *ngIf="(initiateManualSearch && currentHierarchy?.defaultData?.length > 0) || (((tabValue?.name | translate) === ('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION' | translate) || (tabValue?.name | translate) === ('COMMON.GLOBAL_SEARCH.SALES_REGION' | translate)) && currentHierarchy?.defaultData?.length > 0 &&  !searchInput)"
                    [heading]="currentHierarchy?.name"
                    [items]="filterResults(currentHierarchy?.defaultData, 'ContextPointName')" [enableMultiSelect]="enableMulitpleSelection ? tabValue?.subGroups?.enableMultipleSelection : false"
                    [selectedItem]="selectedItem" [searchInput]="searchInput" [iconClass]="'multi-search-icon'" [displaySecondaryText]="enableMulitpleSelection ? tabValue?.subGroups?.enableMultipleSelection : false"
                    [listIconPath]="'../../../../../assets/images/global-search/multi-search-icon.svg'"
                    (itemSelected)="selectedValue($event)" [setHeight]="false"></nalco-result-list>
            </div>
        </ul>

        <div class="text-center" *ngIf="isloading">
            <img src="../../../../../assets/images/fi-refresh-circular-spinner.png" alt="loading.."
                class="search-loader" style="height: 72px; width: 72px;">
        </div>
        <div class="error-container" *ngIf="resultInfo && searchInput">
            <div class="error-icon">
                <div class="list-icon">
                    <img src="../../../../../assets/images/global-search/search-bar-icon.svg"
                        class="search-result-icon">
                </div>
            </div>
            <h6 *ngIf="!showErrorMessage">{{'COMMON.GLOBAL_SEARCH.NO' | translate}} {{tabValue.name | translate}}
                {{'COMMON.GLOBAL_SEARCH.FOUND' | translate}}</h6>
            <p> {{resultInfo}}
            </p>
        </div>
    </div>
    <div class="modal-button" *ngIf="tabValue.enableSelectionButtons" style="display: flex;gap: 10px;float: right;">
        <button [ngClass]="enableMulitpleSelection ? 'btn btn-no-border' : 'btn btn-secondary'"
            (click)="setInitialData();activeModal.close()">{{'COMMON.GLOBAL_SEARCH.CANCEL' | translate}}</button>
        <button [ngClass]="showNextButton ? 'btn btn-secondary' : 'btn btn-primary'"
            (click)="triggerSelection()">{{'COMMON.GLOBAL_SEARCH.APPLY' | translate}}</button>
        <button class="btn btn-secondary" *ngIf="(showNextButton && currentIndex > 0)"
            (click)="onBackButtonClicked()"> <img class="button_img back_icon"
                    src="../../../../../assets/images/global-search/arrow-left-blue.svg" alt="icon" /> {{'COMMON.GLOBAL_SEARCH.BACK' | translate}} </button>
        <button class="btn btn-primary" *ngIf="(showNextButton && currentIndex < tabValue?.hierarchyValues?.length - 1)" [disabled]="disableMultiSelectButtons"
            (click)="onNextButtonClick()">{{'COMMON.GLOBAL_SEARCH.NEXT' | translate}}  <img class="button_img next_icon"
                    src="../../../../../assets/images/global-search/arrow-right-white.svg" alt="icon" /></button>
    </div>
</div>